// src/utils/avatarFallback.js
const getInitials = (name = "") => {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const stringToColor = (str = "") => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = "#";
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff;
    color += value.toString(16).padStart(2, "0");
  }
  return color;
};

/**
 * คืน HTML string ของ fallback avatar
 * @param {string} name ชื่อ/ข้อความใช้สร้างตัวอักษรและสี
 * @param {object} opts กำหนดขนาด/สี/ฟอนต์
 *  - size: px (default 64)
 *  - color: สีตัวอักษร/เส้น (default จากชื่อ)
 *  - fontSize: px (default 22)
 *  - fontWeight: (default 700)
 */
export const buildFallbackAvatar = (name = "", opts = {}) => {
  const initials = getInitials(name);
  const color = opts.color || stringToColor(name);
  const size = opts.size ?? 64;
  const fontSize = opts.fontSize ?? 22;
  const fontWeight = opts.fontWeight ?? 700;

  return `
    <div class="avatar-fallback"
         style="
           width:${size}px;
           height:${size}px;
           display:flex;
           align-items:center;
           justify-content:center;
           background: transparent;
           color:${color};
           border: none;
           border-radius:50%;
           box-sizing:border-box;
           font-weight:${fontWeight};
           font-size:${fontSize}px;
           box-shadow:none;
         ">
      ${initials}
    </div>
  `;
};
